/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
  GetApiV1PersonSharedAccountTypeDropdown401,
  GetApiV1PersonSharedAccountTypeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedAccountTypeDropdown.ts";

function getGetApiV1PersonSharedAccountTypeDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/account-type-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EAccountType para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tipos de conta bancária para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/account-type-dropdown}
 */
export async function getApiV1PersonSharedAccountTypeDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedAccountTypeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAccountTypeDropdown401
      | GetApiV1PersonSharedAccountTypeDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedAccountTypeDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
